module.exports = __webpack_public_path__ + "img/arrow-up-3.57b25e20.svg";